import React from 'react';
import { EmptyState } from '../../components/ui/EmptyState';

const PRIORITY_DOT = {
  critical: 'priority-dot--critical',
  high:     'priority-dot--high',
  medium:   'priority-dot--medium',
  low:      'priority-dot--low',
};

const AssignIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

function QueueItem({ job, onAssign }) {
  return (
    <li
      className="dispatch-queue-item"
      draggable
      onDragStart={(e) => e.dataTransfer.setData('text/job-id', job.id)}
    >
      <span className={`priority-dot ${PRIORITY_DOT[job.priority] ?? PRIORITY_DOT.low}`} aria-hidden="true" />
      <div className="dispatch-job-info min-w-0 flex-1">
        <p className="dispatch-job-id">{job.id}</p>
        <h3 className="dispatch-job-title">{job.title}</h3>
        <p className="dispatch-job-meta">{job.customer}</p>
      </div>
      <button
        type="button"
        className="ui-button ui-button--secondary ui-button--sm"
        onClick={onAssign}
        aria-label={`Assign ${job.title}`}
      >
        <AssignIcon />
        Assign
      </button>
    </li>
  );
}

export function StatusQueue({ jobs, timeline, onAssign }) {
  const firstOpenSlot = timeline.find((slot) => !slot.job);

  return (
    <div className="dispatch-pane">
      <div className="dispatch-pane-header">
        <span className="dispatch-pane-title">Queue</span>
        {jobs.length > 0 && (
          <span className="dispatch-pane-count">{jobs.length}</span>
        )}
      </div>

      {jobs.length === 0 ? (
        <EmptyState
          title="Queue is clear"
          message="No unassigned jobs right now."
        />
      ) : (
        <ul className="dispatch-queue-list" role="list">
          {jobs.map((job) => (
            <QueueItem
              key={job.id}
              job={job}
              onAssign={() => firstOpenSlot && onAssign(job.id, firstOpenSlot.id)}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
